import { useContext, useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { CompetitionContext } from '../Context/CompetitionContext';

const Teams = () => {
  const context = useContext(CompetitionContext);
  const { id, teamId } = useParams();
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getTeams();
      await getCompetitionRegister();
    };
    getData();
  }, [id, search]);

  const getTeams = async () => {
    setLoading(true);
    await get(
      `/team/competition-register/${id}`,
      (res) => {
        context.teams = res;
      },
      (err) => {
        error('دریافت اطلاعات تیم ها با خطا مواجه شد');
        setLoading(false);
      },
    );
  };
  const getCompetitionRegister = async () => {
    setLoading(true);
    await get(
      `/competition-register/${id}`,
      (res) => {
        context.competitionRegister = res?.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات مسابقه با خطا مواجه شد');
        setLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title={`لیست  تیم های  مسابقه ${context.competitionRegister?.competition?.title}`}
          showBackBtn={true}
          showCreateBtn={false}
          showFilterBtn={true}
          backPath={`/competition/competition-register?competition_id=${context.competitionRegister?.competition?.id}`}
        />
        <Datatable
          data={context.teams?.data}
          editUrl='#'
          meta={context.teams?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          disableAllActions={true}
          basePagePath={`/competition/${id}/team`}
          columns={['نام تیم', 'استان', 'شرکت کنندگان']}
          rows={[
            { name: 'name', type: 'string' },
            { name: 'province.name', type: 'relation', relType: 'string' },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'مشاهده',
              link: `/competition-register/${context.competitionRegister?.id}/team/{id}/users`,
              params: ['id'],
            },
          ]}
        />
      </Master>
    </>
  );
};
export default Teams;
